import React from 'react';
import styles from './stats.module.css';
import { formatNumber, formatPercent } from '../utils/format';

/**
 * Funil em barras centralizadas, cada etapa proporcional à primeira, com a
 * % em relação à primeira etapa ao lado.
 * `steps`: [{ label, value, color }]
 */
const Funnel = ({ steps }) => {
  const first = Number(steps[0]?.value) || 0;
  if (first === 0) return <div className={styles.emptyChart}>Nenhum lead no período.</div>;

  return (
    <div className={styles.funnel}>
      {steps.map((step, index) => {
        const value = Number(step.value) || 0;
        return (
          <div key={step.label} className={styles.funnelStep}>
            <div className={styles.funnelBarWrap}>
              <div className={styles.funnelBar} style={{ width: `${Math.max((value / first) * 100, 30)}%`, background: step.color }}>
                <span>{step.label}</span>
                <span>{formatNumber(value)}</span>
              </div>
            </div>
            <span className={styles.funnelRate}>{index === 0 ? '' : formatPercent((value / first) * 100)}</span>
          </div>
        );
      })}
    </div>
  );
};

export default Funnel;
